import React from 'react';
import { Box, Link, Typography } from '@mui/material';
import { CheckCircle } from '@mui/icons-material';
import { adminColors, adminTypography } from '../../../../styles/adminDesignTokens';
import { adminLogPanelSx, adminTextLinkSx } from '../../../../styles/adminComponentStyles';

type LogsFetchState = 'idle' | 'fetching' | 'updated';

type AgentConfigurationLogsSectionProps = {
  logsFetchState: LogsFetchState;
  onGetLatestLogs: () => void;
  onDownloadLogs: () => void;
  lastFetchedLabel: string | null;
};

const AgentConfigurationLogsSection: React.FC<AgentConfigurationLogsSectionProps> = ({
  logsFetchState,
  onGetLatestLogs,
  onDownloadLogs,
  lastFetchedLabel,
}) => {
  return (
    <Box sx={{ mt: 1.5 }}>
      <Box
        sx={adminLogPanelSx}
      >
        <Box>
          <Link
            component="button"
            variant="body2"
            onClick={onGetLatestLogs}
            sx={{
              ...adminTextLinkSx,
              color:
                logsFetchState === 'fetching'
                  ? adminColors.warning
                  : logsFetchState === 'updated'
                    ? adminColors.success
                    : adminColors.primary,
              cursor: logsFetchState === 'fetching' ? 'default' : 'pointer',
              pointerEvents: logsFetchState === 'fetching' ? 'none' : 'auto',
              display: 'flex',
              alignItems: 'center',
              gap: 0.75,
            }}
          >
            {logsFetchState === 'fetching' ? (
              <img src="/Icons/ri_hourglass-fill.svg" width={20} height={20} alt="Fetching logs" />
            ) : null}
            {logsFetchState === 'updated' ? <CheckCircle sx={{ color: adminColors.success, fontSize: 20 }} /> : null}
            {logsFetchState === 'fetching'
              ? 'Fetching logs ...'
              : logsFetchState === 'updated'
                ? 'Logs Updated'
                : 'Get Latest Logs'}
          </Link>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mt: 0.75 }}>
            <Typography
              component="span"
              sx={{
                ...adminTypography.helper,
                color: adminColors.subtleText,
                fontWeight: 600,
              }}
            >
              Last fetched
            </Typography>
            <Typography
              component="span"
              sx={{
                ...adminTypography.helper,
                color: adminColors.subtleText,
                fontStyle: 'italic',
              }}
            >
              {lastFetchedLabel || '—'}
            </Typography>
          </Box>
        </Box>

        <Link
          component="button"
          variant="body2"
          onClick={onDownloadLogs}
          sx={{
            ...adminTextLinkSx,
            display: 'flex',
            alignItems: 'center',
            gap: 0.5,
            fontWeight: 600,
            whiteSpace: 'nowrap',
          }}
        >
          <img src="/Icons/DownloadLogs.svg" width={24} height={24} alt="Download logs" />
          Download Logs
        </Link>
      </Box>
    </Box>
  );
};

export default React.memo(AgentConfigurationLogsSection);
